export default "__VITE_ASSET__CU2nO30O__"